var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1397 5109 c-106 -25 -201 -104 -251 -209 l-31 -65 0 -2275 0 -2275 31 -65 c39 -83 101 -145 184 -184 l65 -31 1165 0 1165 0 65 31 c82 39 144 101 184 184 l31 65 0 2275 0 2275 -31 65 c-40 83 -102 145 -184 184 l-65 31 -1145 2 c-646 1 -1161 -3 -1183 -8z m2029 -234 c49 -20 70 -71 50 -119 -17 -40 -42 -56 -89 -56 -95 0 -122 137 -34 175 40 18 32 18 73 0z m-366 -80 l0 -55 -500 0 -500 0 0 55 0 55 500 0 500 0 0 -55z m670 -2065 l0 -1760 -1170 0 -1170 0 0 1760 0 1760 1170 0 1170 0 0 -1760z m-720 -2190 l0 -140 -450 0 -450 0 0 140 0 140 450 0 450 0 0 -140z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.77a56f61feb96153ccc28c2061eeac1e.svg";
export { ForwardRef as ReactComponent };